import {Middleware, Store} from 'redux';
import {middleware as reduxPackMiddleware} from 'redux-pack';

import {StaticConfig} from 'config/staticConfig';
import {configureReduxStore} from 'configure-store';
import appReducers, {RootState} from 'ducks';
import analyticsMiddleware from 'middleware/analytics';
import sessionActivity from 'middleware/sessionActivity';
import sessionStorageMiddleware from 'middleware/sessionStorage';
import syncReduxBetweenTabs from 'middleware/syncReduxBetweenTabs';
import {SESSION_STORAGE_NAMESPACE} from 'types/SessionNamespace';

export const middleware: Middleware[] = [reduxPackMiddleware, sessionStorageMiddleware, analyticsMiddleware];

if (!StaticConfig.mobileApplicationLoader) {
  middleware.push(sessionActivity);
  middleware.push(syncReduxBetweenTabs);
}

const storedState = JSON.parse(window.sessionStorage.getItem(SESSION_STORAGE_NAMESPACE)!) || {};

function configureAppStore(data?: RootState): Store {
  return configureReduxStore(appReducers, middleware, data, storedState);
}

export default configureAppStore;
